import { Button, Checkbox, Grid, Input, Text } from '@common'
import { useState } from 'react'

interface IDuplicateAssetForm {
  assetID: string,
  sourceAssetStatus: string,
  onDuplicateClick?: (newAssetId: string, isActive: boolean) => void,
  isLoadingDuplicate: boolean,
}

const DuplicateAssetForm = ({ assetID, sourceAssetStatus, onDuplicateClick, isLoadingDuplicate }: IDuplicateAssetForm) => {
  const [newAssetIDState, setNewAssetIDState] = useState<string>('')
  const [isActive, setIsActive] = useState<boolean>(sourceAssetStatus === 'A')

  return (
    <Grid colGap="mini">
      <Grid.Item>
        <Text light>
          Enter the Asset Id for your new asset:

        </Text>
      </Grid.Item>
      <Grid.Item>
        <Input
          onChange={({target}) => setNewAssetIDState(target.value)}
          value={newAssetIDState}
          autoFocus
          autocomplete="off"
          maxLength={12}
        />
      </Grid.Item>
      <Grid.Item>
        <Checkbox
          checked={isActive}
          onChange={() => setIsActive(prev => !prev)}
          label="Asset is active once duplicated"
        />
      </Grid.Item>
      <Grid.Item>
        <Button
          flex
          onClick={() => onDuplicateClick(newAssetIDState, isActive)}
          appearance="primary"
          intent="default"
          disabled={isLoadingDuplicate || !newAssetIDState}
          loading={isLoadingDuplicate}
        >
          Duplicate Asset {assetID}
        </Button>
      </Grid.Item>
    </Grid>
  )
}
export default DuplicateAssetForm
